import pino from 'pino'
import { getLogLevelByHostname } from '@/config/logger'

const logger = pino({
  level: getLogLevelByHostname(),
  prettyPrint: true,
})

logger.debug('Nível de log: ', getLogLevelByHostname())

export default logger
